import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { api } from '@/lib/api';

/**
 * Validates persisted auth token on mount.
 * Calls GET /auth/me to verify the JWT is still valid and refreshes
 * user data in the store. If the token is invalid/expired, auto-logout.
 */
export function useAuthInit() {
  const { token, isAuthenticated, login, logout } = useAuthStore();

  useEffect(() => {
    if (!token || !isAuthenticated) return;

    api.getMe()
      .then(({ user }) => {
        // Refresh user data in store (token stays the same)
        login(token, user);
      })
      .catch(() => {
        // Token invalid or expired — clean up
        logout();
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only on mount
}
